import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import dayjs from 'dayjs';

export interface PagingToken<T> {
    total: number;
    data: T;
}

export interface PagingTokenFixed<T> extends PagingToken<T> {
    filtered: number;
    totalList?: number;
}

export function emptyPagingToken<T>(): PagingTokenFixed<T[]> {
    return { data: [], total: 0, filtered: 0 };
}

export interface FetchArgs {
    filter?: any;
    queryFilter?: any[];
    sort?: { field: string; dir?: 'asc' | 'desc' | 0 | 1; force?: boolean };
    skip: number;
    pageSize: number;
}

export function objectToFilters(filter: CompositeFilterDescriptor, obj: any): void {
    for (const prop in obj) {
        const val = obj[prop];
        const ix = filter.filters.findIndex((f: any) => f.filters?.[0] && f.filters[0].field === prop);
        const iy = filter.filters.findIndex((f: any) => f.field === prop);
        if (ix >= 0) {
            if (val) {
                const existing: any = filter.filters[ix];
                existing.filters[0].value = val;
            } else {
                filter.filters.splice(ix, 1);
            }
        } else if (iy >= 0) {
            if (val) {
                const existing: any = filter.filters[iy];
                existing.value = val;
            } else {
                filter.filters.splice(iy, 1);
            }
        } else if (val) {
            const isValidDate = typeof val === 'string' || val instanceof Date ? dayjs(val).isValid() : false;
            if (isValidDate) {
                filter.filters.push({ filters: [{ field: prop, operator: 'gte', value: val }], logic: 'and' });
            } else {
                filter.filters.push({ filters: [{ field: prop, operator: 'eq', value: val }], logic: 'and' });
            }
        }
    }
}

export function objectToFilter(filter: CompositeFilterDescriptor, obj: any): void {
    for (const prop in obj) {
        const val = obj[prop];
        const ix = filter.filters.findIndex((f: any) => f.filters?.[0] && f.filters[0].field === prop);
        const iy = filter.filters.findIndex((f: any) => f.field === prop);
        if (ix >= 0) {
            if (val) {
                const existing: any = filter.filters[ix];
                existing.filters[0].value = val;
            } else {
                filter.filters.splice(ix, 1);
            }
        } else if (iy >= 0) {
            if (val) {
                const existing: any = filter.filters[iy];
                existing.value = val;
            } else {
                filter.filters.splice(iy, 1);
            }
        } else if (val) {
            filter.filters.push({ filters: [{ field: prop, operator: 'eq', value: val }], logic: 'and' });
        }
    }
}

export function filterToObject(filter: CompositeFilterDescriptor): any {
    const result = {};
    innerToObject(result, filter);
    return result;
}

function innerToObject(obj: any, filter: any): void {
    if (filter?.filters?.length) {
        for (const innerFilter of filter.filters) {
            innerToObject(obj, innerFilter);
        }
    } else if (filter.field) {
        if (obj[filter.field]) {
            obj[filter.field] = [].concat(obj[filter.field], filter.value);
        } else {
            obj[filter.field] = filter.value;
        }
    }
}

export function flatten<T>(arrs: T[][]): T[] {
    return [].concat(...arrs);
}
